import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceApiService } from '@spike/core';

// Models
import { InvestmentRecap } from "../../models/investment-recap.model";

// PrimeNG
import { Button } from "primeng/button";
import { AbstractPageComponent, BasePageComponent, NoResultComponent } from '@spike/scaffolds';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { InvestmentsTableComponent } from '../../components/investments-table/investments-table';
import { IsinSidePanelComponent } from '../../toggle-panels/isin-side-panel/isin-side-panel';
import { NewIsinSidePanelComponent } from '../../toggle-panels/new-isin-side-panel/new-isin-side-panel';

@Component({
  selector: 'app-investment-page',
  templateUrl: './investment-page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, BasePageComponent, NoResultComponent, Button, InvestmentsTableComponent, NewIsinSidePanelComponent, IsinSidePanelComponent]
})
export class InvestmentPageComponent extends AbstractPageComponent {
  // Inject
  private readonly resourceApi = inject(ResourceApiService);

  public readonly breadcrumb = [{ label: 'Investimenti' }];

  // Signals di Stato Locale
  public readonly isSidepanelDetailVisible = signal<boolean>(false);
  public readonly isSidepanelAddVisible = signal<boolean>(false);
  public readonly selectedInvestment = signal<InvestmentRecap | undefined>(undefined);

  // Resource: Caricamento dati reattivo
  public readonly investmentRecapResource = this.resourceApi.selectAll<InvestmentRecap>(signal(EntityApiEnum.FIN_INVESTMENT_RECAP));

  // --- Computed State (Derivati automaticamente dalla risorsa) ---
  public readonly investmentRecapList = computed(() => this.investmentRecapResource.value() ?? []);
  public readonly activeInvestments = computed(() => this.investmentRecapList().filter(i => i.quantity !== 0));
  public readonly closedInvestments = computed(() => this.investmentRecapList().filter(i => i.quantity === 0));

  public onSelect(item: InvestmentRecap) {
    this.selectedInvestment.set(item);
    this.isSidepanelDetailVisible.set(true);
  }

  public onAdd() {
    this.isSidepanelAddVisible.set(true);
  }

  public onDelete(){
    this.investmentRecapResource.reload();
    this.isSidepanelDetailVisible.set(false);
  }
  
  public closeSidePanel(){
    this.isSidepanelDetailVisible.set(false);
    this.isSidepanelAddVisible.set(false);
    this.selectedInvestment.set(undefined);
  }

  public onSave(){
    this.investmentRecapResource.reload();
    this.isSidepanelAddVisible.set(false);
  }
  
}